<template>
  <v-dialog :value="value" width="500px" persistent>
    <v-card>
      <v-card-title>Criar token de API</v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="10">
            <label class="detail-title">Fornecedor</label>
            <v-text-field v-model="provider" class="mb-0" outlined hide-details />
          </v-col>
        </v-row>
        <mf-action-buttons
          :primary-button="{
            text: 'Criar Token',
            action: createAPIToken,
            isVisible: true,
            isLoading: loading,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: () => $emit('input', false),
            isVisible: true,
            isDisabled: loading,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { CREATE_API_INTEGRATION_TOKEN } from '@/modules/configuracoes-admin/graphql'

export default {
  name: 'CreateAPIToken',
  props: {
    value: Boolean,
  },
  data: () => ({
    provider: '',
    loading: false,
  }),
  methods: {
    async createAPIToken() {
      this.loading = true
      try {
        await this.$apollo.mutate({
          mutation: CREATE_API_INTEGRATION_TOKEN,
          variables: {
            provider: this.provider,
          },
        })
        this.$emit('created', true)
      } catch (e) {
        this.$snackbar({ message: 'Erro ao criar API token', snackbarColor: 'error' })
      }
      this.$emit('input', false)
    },
  },
}
</script>
